import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { RichTextEditor } from "Components/RichTextEditor";
import { newAuthService } from "Service/Axios";
import { creatReminderUrl } from "Constant/api";
import { Validator } from "Utils/validator";
import { validateTextEdiorContent } from "Utils";

export const SendReminder = ({ show, recommendationDetails, toggle }) => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    dueDate: "",
    customMessage: "",
  });

  const [errMsg, setErrMsg] = useState({
    dueDate: "",
    customMessage: "",
  });

  const { dueDate, customMessage } = formData;

  // On Change
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    if (e.target.name === "dueDate") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          dueDate: t("common.messages.error.common.dueDate.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          dueDate: "",
        }));
      }
    }
    if (e.target.name === "customMessage") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          customMessage: t("common.messages.error.common.customMessage.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          customMessage: "",
        }));
      }
    }
  };

  const handleChangeCustomMessage = (value) => {
    const newValue = validateTextEdiorContent(value);
    setFormData((prev) => ({
      ...prev,
      customMessage: newValue,
    }));
    if (!Validator.text(newValue)) {
      setErrMsg((prev) => ({
        ...prev,
        customMessage: t("common.messages.error.common.customMessage.blank"),
      }));
    } else {
      setErrMsg((prev) => ({
        ...prev,
        customMessage: "",
      }));
    }
  };

  // Validation
  const getValidation = () => {
    return new Promise((resolve) => {
      if (Validator.text(dueDate) && Validator.text(customMessage)) {
        resolve(true);
      } else {
        if (!Validator.text(dueDate)) {
          setErrMsg((prev) => ({
            ...prev,
            dueDate: t("common.messages.error.common.dueDate.blank"),
          }));
        }

        if (!Validator.text(customMessage)) {
          setErrMsg((prev) => ({
            ...prev,
            customMessage: t(
              "common.messages.error.common.customMessage.blank"
            ),
          }));
        }

        resolve(false);
      }
    });
  };

  // Submit & Reset
  const handleSubmit = async () => {
    const validationStatus = await getValidation();
    if (validationStatus) {
      try {
        const payload = {
          ...formData,
          email: recommendationDetails?.email,
        };
        const response = await newAuthService(
          creatReminderUrl,
          "POST",
          payload
        );
        if (response.status) {
          toggle();
          toast.success(t("common.messages.notification.success.sendReminder"));
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error(
          t("common.messages.notification.failed.somethingWentWrong")
        );
      }
    }
  };

  return (
    <Modal
      className="text-start modal-slider fade right modal-max-w-780"
      show={show}
      onHide={toggle}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <h3 className="modal-title fs-5">Send Reminder</h3>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="d-flex flex-column row-gap-4">
          <div>
            <div className="p-4 rounded-2 border border-slate-200 bg-slate-100">
              <Row className="gy-3">
                <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="">
                    <label htmlFor="dueDate" className="form-label">
                      {t("common.label.dueDate")}
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="dueDate"
                      name="dueDate"
                      value={dueDate}
                      onChange={handleChange}
                    />
                    {errMsg.dueDate && (
                      <p className="error">{errMsg.dueDate}</p>
                    )}
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="">
                    <label htmlFor="institute" className="form-label">
                      Custom message
                    </label>
                    <RichTextEditor
                      value={customMessage}
                      onChange={handleChangeCustomMessage}
                    />
                    {errMsg.customMessage && (
                      <p className="error">{errMsg.customMessage}</p>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <button className="btn btn-secondary flex-none" onClick={handleSubmit}>
          Send Reminder
        </button>
      </Modal.Footer>
    </Modal>
  );
};
